import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

const REDIRECT_LOGIN_URL = process.env.REACT_APP_REDIRECT_LOGIN_URL;

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.href = REDIRECT_LOGIN_URL;
    }
    return Promise.reject(error);
  }
);

export const commonRequest = async (
  method,
  url,
  body = {},
  customHeaders = {},
  responseType = 'json'
) => {
  try {
    const response = await axiosInstance({
      method,
      url,
      data: body,
      headers: { ...customHeaders },
      responseType,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};